export interface IDateRange {
  start: { toString(): string };
  end: { toString(): string };
}

const formatDateRangeParams = (dateRange?: IDateRange): string => {
  if (!dateRange) {
    return '';
  }
  return `?start=${dateRange.start.toString()}&end=${dateRange.end.toString()}`;
};

export const PATHS = {
  HOME: '/',

  ACCOUNTS: '/accounts',
  DASHBOARD: '/dashboard',
  ACCOUNT: (accountId: string, dateRange?: IDateRange) => `/accounts/${accountId}${formatDateRangeParams(dateRange)}`,

  LOGIN: '/login',
  MERCHANTS: '/merchants',
  MERCHANT: (merchantId: string, dateRange?: IDateRange) =>
    `/merchants/${merchantId}${formatDateRangeParams(dateRange)}`,
  ONBOARDING: '/onboarding',
  OBLIGATIONS: '/obligations',
  SETTINGS: '/settings',
  SPENDING: (dateRange?: IDateRange) => `/spending${formatDateRangeParams(dateRange)}`,
  RECURRING_TRANSACTIONS: '/recurring-transactions',
  ASSISTANT: '/assistant',
  TRANSACTION_ROLLUPS: '/admin/transactions-chart-demo',
  DEBUG_SENTRY_TEST: '/debug/sentry-test',
  DEBUG_ENVIRONMENT: '/debug/environment',
} as const;

export type PathKey = keyof typeof PATHS;
export type PathValue = (typeof PATHS)[PathKey];
